module.exports = "<statusbar></statusbar>\n<div class=\"inset\"></div>\n<div layout=\"column\" md-whiteframe=\"z1\">\n    <steps-list></steps-list>\n    <div ui-view=\"content\" flex=\"50\"></div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/evaluation/evaluationView.html
// module id = 196
// module chunks = 0